module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Herznach-Ueken_COA-f85ca9f09cbab3d59525c218f5641199.svg";